import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart as faHeartFull,
  faPlay
} from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartEmpty } from "@fortawesome/free-regular-svg-icons";
import {
  ThumbnailContainer,
  ThumbnailLink,
  Thumbnail,
  ThumbnailCaptionContainer,
  ThumbnailCaption,
  ThumbnailCaptionTitle,
  ThumbnailCaptionIcon,
  ThumbnailSubtitle
} from "../styled-components/Thumbnail";
import { IconButton } from "../styled-components";
import AppSettings from "../settings";
import localize from "../util/localizeUtils";

const $ = window.$;

const DEFAULT_THUMB = "images/blankImageReplaceable.png";

const Field = styled.div`
  line-height: 1rem;
  padding: 2px 0;
`;

const FieldLabel = styled.label`
  color: rgb(107, 107, 107);
  padding-right: 0.2rem;
`;

const DetailsRow = styled(ThumbnailLink)`
  display: flex;
  flex-direction: row;
  margin: 8px 4px;
  text-align: left;
  width: calc(100% - 8px);
`;

const PlayButtonOverlay = styled.div`
  align-self: flex-end;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  display: block;
  font-size: 16px;
  height: 21px;
  margin-top: -21px;
  position: relative;
  text-align: center;
  width: 100%;
`;

const HeartIconButton = styled(IconButton)`
  color: ${props =>
    props.full ? props.theme.colors.red : props.theme.button.icon.color};
  z-index: 2;
`;

class AssetThumbnail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      direction: "row",
      displayPlayButton: false,
      error: false
    };
  }

  componentDidMount() {
    this.addListeners();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.displayPlayButton !== this.state.displayPlayButton ||
      nextState.isDetailsView !== this.props.isDetailsView
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isDetailsView !== this.props.isDetailsView) {
      this.addListeners();
    }
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  addListeners = () => {
    $(this.thumbnailLink)
      .on("click", this.handleAssetClick)
      .on("dblclick", this.handleAssetDoubleClick);
    $(this.playButton).on("dblclick", this.handleAssetDoubleClick);
  };

  removeListeners = () => {
    $(this.thumbnailLink)
      .off("click", this.handleAssetClick)
      .off("dblclick", this.handleAssetDoubleClick);
    $(this.playButton).off("dblclick", this.handleAssetDoubleClick);
  };

  handleAssetClick = event => {
    event.preventDefault();
    if (this.previewWindow) {
      this.previewWindow.close();
    }
    const {
      filePath,
      frameRate,
      id,
      isFavorite,
      title,
      thumbnailUrl,
      provider
    } = this.props;
    this.props.onClick({
      filePath,
      frameRate,
      isFavorite,
      id,
      title,
      thumbnailUrl,
      provider
    });
  };

  handleAssetDoubleClick = event => {
    event.preventDefault();
    const {
      filePath,
      frameRate,
      id,
      isFavorite,
      title,
      thumbnailUrl,
      provider,
      categories,
      assetUrl
    } = this.props;
    this.props.onDoubleClick({
      assetUrl,
      filePath,
      categories,
      frameRate,
      isFavorite,
      id,
      title,
      thumbnailUrl,
      provider
    });
  };

  dragStart = event => {
    if (!this.props.onDragStart) {
      return;
    }
    const { id, title, thumbnailUrl, provider } = this.props;
    const data = {
      id,
      title,
      thumbnailUrl,
      provider
    };
    this.props.onDragStart(event, data);
  };

  dragEnd = event => {
    if (!this.props.onDragEnd) {
      return;
    }

    this.props.onDragEnd(event);
  };

  cleanImageUrl = thumbnailUrl => {
    if (thumbnailUrl) {
      if (thumbnailUrl.includes("http://")) {
        return thumbnailUrl;
      }
      return `${AppSettings.camioServer}${thumbnailUrl}`;
    }
    return thumbnailUrl;
  };

  handleFavoriteToggle(id, favorite) {
    event.preventDefault();
    if (this.props.toggleFavorite) {
      this.props.toggleFavorite(id, favorite);
    }
  }

  handleShowPlayButton = () => {
    if (
      // When FFMpeg gets updated on Lyric Device installer, remove check for video.
      (this.props.fileType &&
        this.props.fileType.toLowerCase() === "video" &&
        this.props.proxyUrl &&
        this.props.proxyUrl.toLowerCase().includes(".webm?")) ||
      (this.props.fileType && this.props.fileType.toLowerCase() === "image") ||
      (this.props.fileType &&
        this.props.fileType.toLowerCase() === "lyric" &&
        this.props.proxyUrl)
    ) {
      this.setState({ displayPlayButton: true });
    }
  };

  handleHidePlayButton = () => {
    this.setState({ displayPlayButton: false });
  };

  openProxy = () => {
    if (this.previewWindow) {
      this.previewWindow.close();
    }

    const proxyWindowUrl = this.props.proxyUrl.replace(
      "..",
      `http://${window.location.hostname}`
    );

    if (this.props.fileType.toLowerCase() === "image") {
      // show preview image
      const sizeToken = this.props.imageSize.split("x");
      const imageWidth = parseInt(sizeToken[0], 10);
      const windowWidth =
        imageWidth > window.outerWidth * 0.75
          ? window.outerWidth * 0.75
          : imageWidth;
      const imageHeight = parseInt(sizeToken[1], 10);
      const windowHeight =
        imageHeight > window.outerHeight * 0.75
          ? window.outerHeight * 0.75
          : imageHeight + 30;
      this.previewWindow = window.open(
        proxyWindowUrl,
        "proxyWindow",
        `width=${windowWidth},height=${windowHeight},location=0,menubar=0,resizable=1,scrollbars=0,titlebar=0,status=0,toolbar=0`,
        true
      );
    } else {
      // show video proxy
      const mediaPlayerWidth = 520;
      const mediaPlayerHeight = 300;
    
      const previewWindowParams = `width=${mediaPlayerWidth + 32},height=${mediaPlayerHeight + 56},location=0,menubar=0,resizable=1,scrollbars=0,titlebar=0,status=0,toolbar=0`;
      this.previewWindow = window.open(proxyWindowUrl, '_blank', previewWindowParams, true);
    }
  };

  extractFolderFromPath = filePath => {
    if (filePath) {
      return filePath.replace(/[^/]*$/, "").replace(/\.\.\/(.+?\/){2}/, "");
    }
    return filePath;
  };

  handleError = () => {
    this.setState({ error: true });
  };

  renderThumbnailView() {
    const {
      fileType,
      id,
      thumbnailUrl,
      isFavorite,
      proxyUrl,
      title,
      assetUrl
    } = this.props;
    const extractedFilePath = this.extractFolderFromPath(assetUrl);
    const displayPlayButton = this.state.displayPlayButton && proxyUrl;
    const isImage = fileType && fileType.toLowerCase() === "image";
    return (
      <ThumbnailContainer id={`asset-thumb-${id}`}>
        <ThumbnailLink
          ref={r => {
            this.thumbnailLink = r;
          }}
          onMouseEnter={this.handleShowPlayButton}
          onMouseLeave={this.handleHidePlayButton}
        >
          <Thumbnail
            src={
              this.state.error
                ? DEFAULT_THUMB
                : this.cleanImageUrl(thumbnailUrl)
            }
            role="presentation"
            alt={title}
            draggable={!!(this.props.onDragStart && this.props.onDragEnd)}
            onDragStart={this.dragStart}
            onDragEnd={this.dragEnd}
            onError={this.handleError}
          />
          {displayPlayButton && (
            <PlayButtonOverlay
              ref={r => {
                this.playButton = r;
              }}
              className="fade"
              onClick={this.openProxy}
            >
              {!isImage && (
                <FontAwesomeIcon icon={faPlay} size="sm" fixedWidth />
              )}
              <span style={{ verticalAlign: "middle" }}>
                {isImage ? localize("viewButton") : localize("playButton")}
              </span>
            </PlayButtonOverlay>
          )}
          <ThumbnailCaptionContainer>
            <ThumbnailCaption>
              <ThumbnailCaptionTitle title={title}>
                {title}
              </ThumbnailCaptionTitle>
              {this.props.toggleFavorite ? (
                <ThumbnailCaptionIcon>
                  <HeartIconButton
                    full={isFavorite}
                    onClick={() => this.handleFavoriteToggle(id, !isFavorite)}
                  >
                    <FontAwesomeIcon
                      fixedWidth
                      size="sm"
                      className="caret-icon"
                      icon={isFavorite ? faHeartFull : faHeartEmpty}
                    />
                  </HeartIconButton>
                </ThumbnailCaptionIcon>
              ) : (
                ""
              )}
            </ThumbnailCaption>
            {this.props.showFilePath ? (
              <ThumbnailSubtitle title={extractedFilePath}>
                {extractedFilePath}
              </ThumbnailSubtitle>
            ) : (
              ""
            )}
          </ThumbnailCaptionContainer>
        </ThumbnailLink>
      </ThumbnailContainer>
    );
  }

  renderTemplateDetails(displayDateTime) {
    const {
      author,
      description,
      fileType,
      keywords,
      subject,
      title,
      fileName
    } = this.props;
    const displayFileType = `${fileType
      .substr(0, 1)
      .toUpperCase()}${fileType.substr(1)}`;
    return (
      <div
        style={{
          flex: 1,
          marginLeft: this.state.direction === "row" ? "0" : "10px",
          wordWrap: "break-word"
        }}
      >
        <Field>
          <FieldLabel>{localize("titleLabel")}</FieldLabel>
          {title}
        </Field>
        <Field>
          <FieldLabel>{localize("lastUploadedLabel")}</FieldLabel>
          {displayDateTime}
        </Field>
        <Field>
          <FieldLabel>{localize("subjectLabel")}</FieldLabel>
          {subject}
        </Field>
        <Field>
          <FieldLabel>{localize("authorLabel")}</FieldLabel>
          {author}
        </Field>
        <Field>
          <FieldLabel>{localize("keywordsLabel")}</FieldLabel>
          {keywords}
        </Field>
        <Field>
          <FieldLabel>{localize("descriptionLabel")}</FieldLabel>
          {description}
        </Field>
        <Field>
          <FieldLabel>{localize("filenameLabel")}</FieldLabel>
          {fileName}
        </Field>
        <Field>
          <FieldLabel>{localize("typeLabel")}</FieldLabel>
          {displayFileType}
        </Field>
      </div>
    );
  }

  renderMediaDetails(displayDateTime) {
    const {
      author,
      description,
      fileName,
      fileType,
      imageSize,
      keywords,
      subject,
      title
    } = this.props;
    const displayFileType = fileName.includes(".")
      ? fileName.split(".").pop()
      : fileType;
    return (
      <div
        style={{
          flex: 1,
          marginLeft: this.state.direction === "row" ? "0" : "10px",
          wordWrap: "break-word"
        }}
      >
        <Field>
          <FieldLabel>{localize("titleLabel")}</FieldLabel>
          {title}
        </Field>
        <Field>
          <FieldLabel>{localize("lastUploadedLabel")}</FieldLabel>
          {displayDateTime}
        </Field>
        <Field>
          <FieldLabel>{localize("subjectLabel")}</FieldLabel>
          {subject}
        </Field>
        <Field>
          <FieldLabel>{localize("authorLabel")}</FieldLabel>
          {author}
        </Field>
        <Field>
          <FieldLabel>{localize("keywordsLabel")}</FieldLabel>
          {keywords}
        </Field>
        <Field>
          <FieldLabel>{localize("descriptionLabel")}</FieldLabel>
          {description}
        </Field>
        <Field>
          <FieldLabel>{localize("filenameLabel")}</FieldLabel>
          {fileName}
        </Field>
        <Field>
          <FieldLabel>{localize("typeLabel")}</FieldLabel>
          {displayFileType}
        </Field>
        <Field>
          <FieldLabel>{localize("sizeLabel")}</FieldLabel>
          {imageSize}
        </Field>
      </div>
    );
  }

  renderMosDetails(displayDateTime) {
    const { author, mediaFields, textFields, templateTitle } = this.props;
    return (
      <div
        style={{
          flex: 1,
          marginLeft: this.state.direction === "row" ? "0" : "10px",
          wordWrap: "break-word"
        }}
      >
        <Field>
          <FieldLabel>{localize("titleLabel")}</FieldLabel>
          {templateTitle}
        </Field>
        <Field>
          <FieldLabel>{localize("createdLabel")}</FieldLabel>
          {displayDateTime}
        </Field>
        <Field>
          <FieldLabel>{localize("authorLabel")}</FieldLabel>
          {author}
        </Field>
        <Field>
          <FieldLabel>{localize("textFieldsLabel")}</FieldLabel>
          {textFields}
        </Field>
        <Field>
          <FieldLabel>{localize("mediaFieldsLabel")}</FieldLabel>
          {mediaFields}
        </Field>
      </div>
    );
  }

  renderDetailsView() {
    const {
      id,
      thumbnailUrl,
      fileType,
      isFavorite,
      lastModifiedDateTime,
      title,
      proxyUrl
    } = this.props;
    const lastUploadedDate = new Date(lastModifiedDateTime);
    const displayDateTime =
      lastUploadedDate.getFullYear() > 1
        ? lastUploadedDate.toLocaleString()
        : "";
    const isMediaAsset =
      fileType &&
      (fileType.toLowerCase() === "image" ||
        fileType.toLowerCase() === "video");
    const displayPlayButton = this.state.displayPlayButton && proxyUrl;
    const isImage = fileType && fileType.toLowerCase() === "image";
    return (
      <DetailsRow
        ref={r => {
          this.thumbnailLink = r;
        }}
      >
        <ThumbnailContainer
          id={`asset-thumb-${id}`}
          style={{ verticalAlign: "top" }}
          ref={r => {
            this.thumbnailLink = r;
          }}
          onMouseEnter={this.handleShowPlayButton}
          onMouseLeave={this.handleHidePlayButton}
        >
          <Thumbnail
            src={
              this.state.error
                ? DEFAULT_THUMB
                : this.cleanImageUrl(thumbnailUrl)
            }
            style={{ maxWidth: "128px", minWidth: "128px", width: "128px" }}
            role="presentation"
            alt={title}
            draggable={this.props.onDragStart && this.props.onDragEnd}
            onDragStart={this.dragStart}
            onError={this.handleError}
          />
          {displayPlayButton && (
            <PlayButtonOverlay
              ref={r => {
                this.playButton = r;
              }}
              className="fade"
              onClick={this.openProxy}
            >
              {!isImage && (
                <img
                  src="images/play_white.png"
                  style={{ paddingRight: "4px", verticalAlign: "middle" }}
                />
              )}
              <span style={{ verticalAlign: "middle" }}>
                {isImage ? localize("viewButton") : localize("playButton")}
              </span>
            </PlayButtonOverlay>
          )}
        </ThumbnailContainer>
        {(fileType &&
          !isMediaAsset &&
          this.renderTemplateDetails(displayDateTime)) ||
          (isMediaAsset && this.renderMediaDetails(displayDateTime)) ||
          (!fileType && this.renderMosDetails(displayDateTime))}
        {this.props.toggleFavorite && (
          <HeartIconButton
            full={isFavorite}
            onClick={() => this.handleFavoriteToggle(id, !isFavorite)}
          >
            <FontAwesomeIcon
              fixedWidth
              size="sm"
              className="caret-icon"
              icon={isFavorite ? faHeartFull : faHeartEmpty}
            />
          </HeartIconButton>
        )}
      </DetailsRow>
    );
  }

  render() {
    return this.props.isDetailsView
      ? this.renderDetailsView()
      : this.renderThumbnailView();
  }
}

AssetThumbnail.defaultProps = {
  filePath: "",
  frameRate: -1,
  categories: [],
  isFavorite: false,
  author: "",
  description: "",
  fileName: "",
  fileType: "",
  imageSize: "",
  keywords: "",
  lastModifiedDateTime: "",
  mediaFields: "",
  proxyUrl: "",
  subject: "",
  templateTitle: "",
  textFields: "",
  title: "",
  isMosObject: false,
  onDoubleClick: () => {},
  onClick: () => {},
  onDragStart: null,
  onDragEnd: null,
  toggleFavorite: null,
  provider: null,
  showFilePath: false,
  assetUrl: "",
  isDetailsView: false
};

AssetThumbnail.propTypes = {
  filePath: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.number),
  frameRate: PropTypes.number,
  isFavorite: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  provider: PropTypes.string,
  author: PropTypes.string,
  description: PropTypes.string,
  fileName: PropTypes.string,
  fileType: PropTypes.string,
  imageSize: PropTypes.string,
  keywords: PropTypes.string,
  lastModifiedDateTime: PropTypes.string,
  mediaFields: PropTypes.string,
  proxyUrl: PropTypes.string,
  subject: PropTypes.string,
  templateTitle: PropTypes.string,
  textFields: PropTypes.string,
  title: PropTypes.string,
  thumbnailUrl: PropTypes.string.isRequired,
  toggleFavorite: PropTypes.func,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  showFilePath: PropTypes.bool,
  assetUrl: PropTypes.string,
  isDetailsView: PropTypes.bool,
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func
};

const mapStateToProps = state => ({
  isDetailsView: state.assets.isDetailsView
});

export default connect(mapStateToProps)(AssetThumbnail);



// WEBPACK FOOTER //
// ./app/components/AssetThumbnail.js